import React, { useState } from 'react';


import Select from '../../../components/ui/Select';
import { useLanguage } from '../../../contexts/LanguageContext';

const BulkActionsBar = ({ 
  selectedCount, 
  onClearSelection, 
  onBulkCategoryChange,
  onBulkDelete 
}) => {
  const [selectedAction, setSelectedAction] = React.useState('');
  const { t } = useLanguage();

  const actionOptions = [
    { value: '', label: t('chooseAction') },
    { value: 'change-category', label: t('changeCategory') },
    { value: 'delete', label: t('deleteSelected') }
  ];

  const handleActionChange = (value) => {
    setSelectedAction(value);
    
    if (value === 'change-category') {
      onBulkCategoryChange();
    } else if (value === 'delete') {
      onBulkDelete();
    }
    
    setTimeout(() => setSelectedAction(''), 100);
  };

  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-sticky">
      <div className="bg-card border border-border rounded-lg shadow-elevation-4 p-4 flex flex-col sm:flex-row items-center gap-4 min-w-[320px] sm:min-w-[480px]">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 bg-accent text-accent-foreground rounded-full font-semibold">
            {selectedCount}
          </div>
          <div>
            <p className="font-medium text-foreground">
              {selectedCount} {selectedCount === 1 ? t('documentSingular') : t('documentPlural')} {t('selected')}
            </p>
            <button
              onClick={onClearSelection}
              className="text-sm text-accent hover:underline"
            >
              {t('clearSelection')}
            </button>
          </div>
        </div>

        <div className="flex items-center gap-2 sm:ml-auto">
          <Select
            options={actionOptions}
            value={selectedAction}
            onChange={handleActionChange}
            className="w-48"
          />
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;